import { render, staticRenderFns } from "./BenefitTypeList.vue?vue&type=template&id=605350c0&"
import script from "./BenefitTypeList.js?vue&type=script&lang=js&"
export * from "./BenefitTypeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports